// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/styles/" + chunkId + "." + {287: "d6fc980c9b27e063",3657: "2ab66cc0d70906ce",}[chunkId] + ".css"
}